import { LitEntity, html, css } from '../../utility/lit-entity';

class BinPhoto extends LitEntity {
  static get properties() {
    return {
      photoHref: { type: String, attribute: false },
      noImageFound: { type: Boolean, attribute: false },
    };
  }

  static get styles() {
    return [css`
      :host {
        display: block;
        width: 100%;
        height: 100%;
        background-position: center;
        background-repeat: no-repeat;
      }
    `];
  }

  render() {
    if (!this.photoHref) {
      return html``;
    }

    return html`
      <style>
        :host {
          background-image: url("${this.photoHref}");
          background-size: ${this.noImageFound ? 'contain' : 'cover'}
        }
      </style>
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    const photos = this.entity && this.entity.getSubEntitiesByRel('https://api.binsentry.com/rel/bin-photo');
    this.noImageFound = !photos || photos.length === 0;
    this.photoHref = this.noImageFound ? '/images/no_image_found.png' : photos.pop().href;
  }
}

window.customElements.define('bin-photo', BinPhoto);
